import { createReducer, on } from '@ngrx/store';

import { setBusinessAccountParentKey } from './business-account-parent-key.actions';


export const initialState = null;

export const businessAccountParentKeyReducer = createReducer(
  initialState,

  on(setBusinessAccountParentKey, (state, { businessAccountParentKey }) => businessAccountParentKey),
);
